import { Container } from "@mui/material";
import { ConcreteTrackerChartBuilder, TrackcerData } from "../builders/TrackerChartBuilder";
import { RopChart } from "../../../main/components/RopChart";


export type TrackerGraphOptions = {
  title?: string;
  data: TrackcerData
  elementRef?: React.MutableRefObject<null>
};

export const TrackerChartBuilder = ({
  title,
  data,
  elementRef
}: TrackerGraphOptions) => {

  const builder = new ConcreteTrackerChartBuilder();
  builder.setTitle(title);
  builder.setData(data)

  const options = builder.getTrackerEchartsOptions();

  return (
    <Container
      ref={elementRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "90%",
      }}
    >
      <RopChart option={options} />
    </Container>);
};
